import React from "react";

import "./style.scss";

interface Props {
    items: string[];
}

/**
 * The share attribute list is a dot separated list of items.
 * The items will be rendered as strings with a title.
 */
export const AttributeList = ({ items }: Props) => {
    return (
        <div className="attributeList">
            {items
                .filter(x => x != null && x !== "")
                .map((label, i) => (
                    <React.Fragment key={i}>
                        <span>{label}</span>
                        {"\u00A0"}
                    </React.Fragment>
                ))}
        </div>
    );
};
